import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import {
  Container, Divider, Image, Loader, Popup, Segment
} from 'semantic-ui-react';

import classNames from 'classnames';

import '../css/ClassCards.less';

import iconAssign from '../img/icon-assign.svg';
import iconCourse from '../img/icon-course.svg';
import iconSettings from '../img/icon-class-settings.svg';
import iconRoster from '../img/icon-roster.svg';
import iconAccommodations from '../img/icon-accommodations.svg';
import iconGroups from '../img/icon-groups.svg';
import iconWorkspace from '../img/icon-workspace.svg';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { VIEW_SELECTION } from '../managers/NavigationManager';

import CourseService from '../services/CourseService';
import PopupService from '../services/PopupService';
import UtilityService from '../services/UtilityService';

@inject(
  'accommodationsManager',
  'appManager',
  'assignmentManager',
  'classroomManager',
  'courseManager',
  'googleClassroomManager',
  'navigationManager',
  'userManager'
)
@observer
class ClassCard extends Component {
  constructor(props) {
    super(props);
    this.ClassCardImage = SatCoreComponent('ClassCardImage');
    this.ClassroomTitle = SatCoreComponent('ClassroomTitle');
    this.GoogleClassroomConnectionLauncherButton = SatCoreComponent('GoogleClassroomConnectionLauncherButton');
    this.InfoIcon = SatCoreComponent('InfoIcon');
  }

  popup = (classroom) => {
    const {
      classroomId, courseManager, userManager, t
    } = this.props;

    if (classroom.courseCount > 0) {
      return (
        <>
          <div className='card-label courses-label'>
            {t('coursesLabel', 'Courses')}
            :
          </div>
          <Popup
            hideOnScroll
            on='click'
            onOpen={() => {
              CourseService.fetchClassroomCourses(classroomId, userManager.isTeacher, userManager.isStudent);
            }}
            position='top right'
            trigger={(
              <div className='clickable courses'>
                <div className='card-list-text card-list-text-courses blue'>{classroom.courseCount}</div>
              </div>
            )}
            wide='very'>
            <>
              {(courseManager.getCourseList(classroomId).length === 0) ?
                <Loader active inline /> : null}

              <div className='courses-popup-list' style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {courseManager.getCourseList(classroomId).map((course, index) => {
                  const courseNameObj = UtilityService.reactHtmlParserWrapper(course.friendlyName || course.name);
                  return (
                    <div key={course.id + classroomId} className='popup-text-wrapper'>
                      <span className='card-list-text'>
                        {`${t('courseLabel', 'Course')} ${index + 1}: `}
                      </span>
                      <span
                        className='card-list-text blue clickable'
                        onClick={() => this.handleClickCourse(classroomId, course)}
                        title={courseNameObj.stripped}>
                        {courseNameObj.parsed}
                      </span>
                    </div>
                  );
                })}
              </div>
            </>
          </Popup>
        </>
      );
    }
    return (
      <>
        <div className='card-label courses-label'>
          {t('coursesLabel', 'Courses')}
          :
        </div>
        <div className='card-list-text card-list-text-courses-none'>{t('none')}</div>
      </>
    );
  }

  handleClick = async () => {
    const {
      classroomId, classroomManager, handleCardClick, navigationManager
    } = this.props;
    classroomManager.setCurrentClassroomId(classroomId);
    const classroom = classroomManager.getClassroom(classroomId);
    await navigationManager.clearAllPaths();
    handleCardClick(classroom.id);
  }

  handleClickCourse = async (classroomId, course) => {
    const { handleClickCourse } = this.props;
    await handleClickCourse(classroomId, course);
  }

  handleRosterClick = async () => {
    const {
      classroomId, classroomManager, navigationManager, handleNavigationClick
    } = this.props;
    classroomManager.setCurrentClassroomId(classroomId);
    const classroom = classroomManager.getClassroom(classroomId);
    await navigationManager.clearAllPaths();
    handleNavigationClick(`/roster?classroomId=${classroom.id}`, classroom.id);
  }

  handleAccommodationsClick = async () => {
    const {
      classroomId, classroomManager, navigationManager, handleNavigationClick
    } = this.props;
    classroomManager.setCurrentClassroomId(classroomId);
    const classroom = classroomManager.getClassroom(classroomId);
    await navigationManager.clearAllPaths();
    handleNavigationClick(`/accommodations?classroomId=${classroom.id}`, classroom.id);
  }

  handleGroupsClick = async () => {
    const {
      classroomId, classroomManager, navigationManager, handleNavigationClick
    } = this.props;
    classroomManager.setCurrentClassroomId(classroomId);
    const classroom = classroomManager.getClassroom(classroomId);
    await navigationManager.clearAllPaths();
    handleNavigationClick(`/groups?classroomId=${classroom.id}&view=${VIEW_SELECTION.GROUPS}`, classroom.id);
  }

  handleSettingsClick = async () => {
    const {
      classroomId, classroomManager, navigationManager, handleNavigationClick
    } = this.props;
    classroomManager.setCurrentClassroomId(classroomId);
    const classroom = classroomManager.getClassroom(classroomId);
    await navigationManager.clearAllPaths();
    handleNavigationClick(`/settings?classroomId=${classroom.id}`, classroom.id);
  }

  handleAssignmentClick = async (activitiesDueTodayCount) => {
    const {
      assignmentManager, classroomId, classroomManager, navigationManager, handleNavigationClick
    } = this.props;
    classroomManager.setCurrentClassroomId(classroomId);
    const classroom = classroomManager.getClassroom(classroomId);
    const now = new Date();
    const dateParam = assignmentManager.convertAssignmentDateToJavaString(now);
    await navigationManager.clearAllPaths();

    const path = (activitiesDueTodayCount !== null)
      ? `/assignments?classroomId=${classroom.id}&filterDate=${dateParam}&view=${VIEW_SELECTION.ASSIGNMENTS}`
      : `/assignments?classroomId=${classroom.id}&view=${VIEW_SELECTION.ASSIGNMENTS}`;
    handleNavigationClick(path, classroom.id);
  }

  handleWorkspaceClick = async () => {
    const { classroomId, handleNavigationClick } = this.props;
    handleNavigationClick(`/workspace?classroomId=${classroomId}&view=${VIEW_SELECTION.WORKSPACE}`, classroomId);
  }

  showContentAssignments = (classroomId, fetchAssignmentsToGrade = false, useAggregateCards = false) => {
    const { showContentAssignments } = this.props;
    showContentAssignments(classroomId, fetchAssignmentsToGrade, useAggregateCards);
  }

  renderInfoBlock = (key, classroom) => {
    const { t } = this.props;
    switch (key) {
      case 'COURSES':
        return this.popup(classroom);
      case 'DUE_TODAY':
        return (
          <>
            <div className='card-label due-today-label'>{t('dueToday')}</div>
            {(classroom.activitiesDueTodayCount > 0) ? (
              <div className='card-list-text blue clickable due-today'
                onClick={() => this.showContentAssignments(classroom.id, false, true)}>
                {classroom.activitiesDueTodayCount}
              </div>
            ) : (
              <div className='card-list-text due-today'>{t('none')}</div>
            )}
          </>
        );
      case 'READY_TO_GRADE':
        return (
          <>
            <div className='card-label ready-grade-label'>{t('readyToGrade')}</div>
            {(classroom.readyToGradeCount > 0) ? (
              <div className='card-list-text blue clickable ready-grade'
                onClick={() => this.showContentAssignments(classroom.id, true, true)}>
                {classroom.readyToGradeCount}
              </div>
            ) : (
              <div className='card-list-text ready-grade'>{t('none')}</div>
            )}
          </>
        );
      default:
        return null;
    }
  };

  renderClassroomCardFooterNavButton = (key) => {
    const {
      accommodationsManager,
      appManager,
      classroomManager,
      isLeadTeacher,
      t,
      userManager
    } = this.props;

    const { isSsoUser, isTeacher } = userManager;
    const renderFooterNavButtonRollover = (buttonKey, rolloverTranslationKey, trigger) => PopupService.renderPopup({
      content: t(rolloverTranslationKey, ''),
      disabled: !t(rolloverTranslationKey, ''),
      key: `${buttonKey}-rollover`,
      trigger,
      wide: false
    });

    switch (key) {
      case 'COURSES':
        return renderFooterNavButtonRollover('COURSES', 'courseInfo', (
          <div className='button'>
            <Image alt='' className='course-icon' src={iconCourse} />
            <div
              className='card-list-text blue clickable course'
              onClick={this.handleClick}>
              {t('course')}
            </div>
          </div>
        ));
      case 'ASSIGNMENTS':
        return renderFooterNavButtonRollover('ASSIGNMENTS', 'assignmentsInfo', (
          <div className='button assignment-icon'>
            <Image alt='' className='assignment-icon' src={iconAssign} />
            <div
              className='card-list-text blue clickable assignment'
              onClick={() => this.handleAssignmentClick(null)}>
              {t('assignments')}
            </div>
          </div>
        ));
      case 'ROSTER':
        return (isTeacher) ? renderFooterNavButtonRollover('ROSTER', 'rosterInfo', (
          <div className='button'>
            <Image alt='' className='roster-icon' src={iconRoster} />
            <div
              className='card-list-text blue clickable roster'
              onClick={this.handleRosterClick}>
              {t('roster')}
            </div>
          </div>
        )) : null;
      case 'CLASS_SETTINGS':
        return ((isTeacher && isLeadTeacher) || (isSsoUser && isTeacher)) ? renderFooterNavButtonRollover('CLASS_SETTINGS', 'classSettingsInfo', (
          <div className='button'>
            <Image alt='' className='settings-icon' src={iconSettings} />
            <div
              className='card-list-text blue clickable settings'
              onClick={this.handleSettingsClick}>
              {t('classSettings')}
            </div>
          </div>
        )) : null;
      case 'ACCOMMODATIONS':
        return (isTeacher && isLeadTeacher && accommodationsManager.includeClassroomAccommodations) ? renderFooterNavButtonRollover('ACCOMMODATIONS', 'accommodationsInfo', (
          <div className='button'>
            <Image alt='' className='accommodations-icon' src={iconAccommodations} />
            <div
              className='card-list-text blue clickable settings'
              onClick={this.handleAccommodationsClick}>
              {t('accommodations')}
            </div>
          </div>
        )) : null;
      case 'GROUPS':
        return (isTeacher && classroomManager.includeGroups) ? renderFooterNavButtonRollover('GROUPS', 'groupsInfo', (
          <div className='button'>
            <Image alt='' className='groups-icon' src={iconGroups} />
            <div
              className='card-list-text blue clickable settings'
              onClick={this.handleGroupsClick}>
              {t('groupsLabel', 'Groups')}
            </div>
          </div>
        )) : null;
      case 'WORKSPACE':
        return isTeacher && appManager.classWorkspaceFeature && userManager.hasManageUploadedFilesPermission ? renderFooterNavButtonRollover('WORKSPACE', 'workspaceInfo', (
          <div className='button'>
            <Image alt='' className='workspace-icon' src={iconWorkspace} />
            <div
              className='card-list-text blue clickable workspace'
              onClick={this.handleWorkspaceClick}>
              {t('workspace')}
            </div>
          </div>
        )) : null;
      default:
        return null;
    }
  };

  render() {
    const {
      classroomId,
      classroomManager,
      defaultImage,
      fetchClassroomData,
      googleClassroomManager,
      openImagePicker
    } = this.props;

    const { allowGoogleClassroomIntegration } = googleClassroomManager;

    const classroom = classroomManager.getClassroom(classroomId);

    const {
      ClassCardImage,
      ClassroomTitle,
      GoogleClassroomConnectionLauncherButton
    } = this;

    const hasClassCardHeaderFlex = allowGoogleClassroomIntegration;

    const infoOrder = classroomManager.classCardInfoOrderArray || ['COURSES', 'DUE_TODAY', 'READY_TO_GRADE'];
    const { teacherClassroomCardFooterNavButtonOrderArray } = classroomManager;

    return (
      <Segment key={classroom.id} className='class-card-satcore list-card'>
        <ClassCardImage
          classroomId={classroomId}
          defaultImage={defaultImage}
          onClick={this.handleClick}
          openImagePicker={openImagePicker} />
        <div className='card-body'>
          <div className='card-info'>
            <Container className={classNames('class-card-header', {
              'class-card-header-flex': hasClassCardHeaderFlex
            })} fluid>
              <ClassroomTitle classroom={classroom} />
              {allowGoogleClassroomIntegration && (
                <GoogleClassroomConnectionLauncherButton
                  classroom={classroom}
                  fetchClassroomData={fetchClassroomData} />
              )}
            </Container>
            <div className='class-card-info'>
              {infoOrder.map((key) => (
                <React.Fragment key={key}>
                  {this.renderInfoBlock(key, classroom)}
                </React.Fragment>
              ))}
            </div>
          </div>
          <Divider />
          <div className='card-nav-buttons teacher-classroom-card-footer-nav-buttons'>
            {teacherClassroomCardFooterNavButtonOrderArray.map((key) => (
              <React.Fragment key={key}>
                {this.renderClassroomCardFooterNavButton(key)}
              </React.Fragment>
            ))}
          </div>
        </div>
      </Segment>
    );
  }
}

export default ClassCard;

SatCoreRegister('ClassCard', ClassCard);
